import React, { useEffect } from 'react';
import { useParams, useNavigate, useLocation, Navigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { SiteNav } from '../components/SiteNav';
import { SiteFooter } from '../components/SiteFooter';
import { ArtifactHero } from '../components/artifact/ArtifactHero';
import { ArtifactGallery } from '../components/artifact/ArtifactGallery';
import { ArtifactDetails } from '../components/artifact/ArtifactDetails';
import { ArtifactRail } from '../components/artifact/ArtifactRail';
import { usePageMeta } from '../hooks/usePageMeta';
import { useArtifactConfig } from '../hooks/useArtifactConfig';
import { findArtifact } from '../data/artifactRealms';
import { LEGACY_SLUGS } from '../data/descentArtifacts';

const ProductPage = () => {
  const { productSlug } = useParams();
  const navigate = useNavigate();
  const dir = useLocation().state?.dir || 0;
  const found = findArtifact(productSlug);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [productSlug]);

  if (LEGACY_SLUGS[productSlug]) return <Navigate to={`/product/${LEGACY_SLUGS[productSlug]}`} replace />;

  if (!found) {
    return (
      <div className="min-h-screen bg-[#06111F] flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-[#F3E8D2] text-2xl mb-4">Artifact not found</h1>
          <Button onClick={() => navigate('/realm/the-deep')} className="bg-[#C8A45D] hover:bg-[#BFA05A] text-[#080A0D]">
            Return to The Deep
          </Button>
        </div>
      </div>
    );
  }

  return <Artifact key={found.realm.key} realm={found.realm} piece={found.piece} dir={dir} />;
};

const Artifact = ({ realm, piece, dir }) => {
  const navigate = useNavigate();
  const config = useArtifactConfig(realm);
  const interest = realm.interest(piece, config.metal, config.stone);
  const request = () => navigate('/#contact', { state: { interest } });

  usePageMeta({
    title: `${piece.name} — ${realm.name} | Ikarus Landed`,
    description: `${piece.creed} ${piece.type} of ${realm.name} by Ikarus Landed, made to order by private commission in ${realm.stones[0].label.toLowerCase()} or ${realm.stones[1].label.toLowerCase()}.`,
  });

  return (
    <div className={`luxury-landing realm ${realm.className} apage`} data-testid="product-page">
      <SiteNav interest={interest} />
      <ArtifactHero realm={realm} piece={piece} isEx={config.isEx} config={config} dir={dir} onRequest={request} />
      <ArtifactGallery piece={piece} isEx={config.isEx} />
      <ArtifactDetails realm={realm} piece={piece} config={config} />
      <ArtifactRail realm={realm} slug={piece.slug} />
      <SiteFooter />
    </div>
  );
};

export default ProductPage;
